import { gql } from "@apollo/client";

const VALIDATE_EMAIL = gql`
  mutation($token: String!) {
    confirmEmail(token: $token)
  }
`;

export default VALIDATE_EMAIL;